"use client";

import React from "react";
import { Search } from "lucide-react";
import { useAction } from "next-safe-action/hooks";

import { Paragraph } from "@/components/ui/typography";

import { searchCourses } from "@/fetchers/store";

import useMoengageEventTracker from "@/hooks/use-moengage";

import EVENT_NAME from "@/hooks/use-moengage/event-name.json";

import { cn } from "@/lib/utils";

function CourseCard({ course }) {
  return (
    <a
      href={`/course-detail/${course.slug}`}
      className="flex py-1 px-4 border-b border-grayscale-line last:border-b-0"
    >
      <Paragraph variant="b4">{course.title}</Paragraph>
    </a>
  );
}

function HeaderSearch() {
  const trackMoengageEvent = useMoengageEventTracker();

  const {
    hasSucceeded,
    result: { data: result },
    execute,
    reset,
  } = useAction(searchCourses);

  const [query, setQuery] = React.useState("");

  React.useEffect(() => {
    const intervalId = window.setTimeout(async () => {
      if (!query.length) return reset();

      execute({ page: 1, pageSize: 10, searchString: query });
    }, 300);

    return () => window.clearTimeout(intervalId);
  }, [query, execute, reset]);

  const handleOnSearchWrapperClick = (e) => {
    e.stopPropagation();

    trackMoengageEvent(EVENT_NAME.SEARCH_CLICKED);
  };

  return (
    <div
      className="relative flex justify-center flex-1 mx-auto"
      data-testid="search-container"
    >
      <div
        className="relative w-full max-w-74"
        data-testid="search-input-wrapper"
        onClick={handleOnSearchWrapperClick}
      >
        <input
          type="text"
          placeholder="Explore StudyIQ"
          className="py-2 px-4 pl-10 border border-primary/60 rounded-lg h-10 w-full"
          data-testid="search-input"
          onChange={(e) => setQuery(e.target.value)}
        />
        <Search
          size={18}
          className="absolute left-3 top-1/2 bottom-0 text-gray-500 -translate-y-1/2"
          data-testid="search-icon"
        />
      </div>

      <div
        className={cn(
          "absolute top-full flex flex-col w-full max-w-96 max-h-80 lg:max-h-120 bg-primary-foreground py-2",
          "shadow border border-grayscale-line rounded-lg z-50 mt-2 overflow-auto",
          { hidden: !hasSucceeded }
        )}
      >
        {result?.courseList?.map((course) => (
          <CourseCard key={course.courseId} course={course} />
        ))}
      </div>
    </div>
  );
}

export default HeaderSearch;
